export default function BackgroundIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2.88623 17.7598C1.98975 17.7598 1.31185 17.5329 0.852539 17.0791C0.393229 16.6253 0.163574 15.9557 0.163574 15.0703V4.95996C0.163574 4.07454 0.393229 3.40495 0.852539 2.95117C1.31185 2.49186 1.98975 2.26221 2.88623 2.26221H17.0972C17.9992 2.26221 18.6799 2.49186 19.1392 2.95117C19.5985 3.40495 19.8281 4.07454 19.8281 4.95996V15.0703C19.8281 15.9557 19.5985 16.6253 19.1392 17.0791C18.6799 17.5329 17.9992 17.7598 17.0972 17.7598H2.88623ZM2.98584 16.1328H17.0059C17.3877 16.1328 17.681 16.0332 17.8857 15.834C18.0905 15.6292 18.1929 15.3276 18.1929 14.9292V5.10107C18.1929 4.70264 18.0905 4.40381 17.8857 4.20459C17.681 3.99984 17.3877 3.89746 17.0059 3.89746H2.98584C2.59847 3.89746 2.30241 3.99984 2.09766 4.20459C1.89844 4.40381 1.79883 4.70264 1.79883 5.10107V14.9292C1.79883 15.3276 1.89844 15.6292 2.09766 15.834C2.30241 16.0332 2.59847 16.1328 2.98584 16.1328Z" />
    </svg>
  );
}
